/**
 * ESTE ARCHIVO ES GENERADO AUTOMÁTICAMENTE. NO EDITAR MANUALLY.
 * Generado por: scripts/compile-eshop-templates.mjs
 */
import { CatalogueTemplateDefinition } from '../schema';

export const PRECOMPILED_DEFINITIONS: Record<string, CatalogueTemplateDefinition> = {
  "default": {
    "id": "default",
    "version": "1.0.0",
    "meta": {
      "label": "Base declarativa",
      "description": "Estructura base para componer diseños de catálogo.",
      "accentColor": "--web-color-3",
      "surfaceColor": "--web-color-1"
    },
    "regions": [
      "hero",
      "header",
      "panel",
      "card"
    ],
    "layout": {
      "hero": {
        "fullWidth": true,
        "tokens": {
          "--catalogue-hero-region-content-width": "var(--catalogue-container-max-width)",
          "--catalogue-hero-region-padding-inline": "var(--catalogue-panel-padding-inline)",
          "--catalogue-hero-region-padding-inline-mobile": "var(--catalogue-space-3)",
          "--catalogue-hero-region-gap-block": "var(--catalogue-space-4)",
          "--catalogue-hero-region-gap-block-mobile": "0"
        }
      }
    },
    "slots": {
      "hero": [
        {
          "block": "Hero",
          "key": "hero"
        }
      ],
      "header": [
        {
          "block": "Brand",
          "key": "brand"
        },
        {
          "block": "Navigation",
          "key": "navigation",
          "when": "hasNavigation"
        },
        {
          "block": "Actions",
          "key": "actions",
          "when": "hasActions"
        },
        {
          "block": "Configurator",
          "key": "configurator",
          "when": "hasConfigurator"
        }
      ],
      "panel": [
        {
          "block": "Toolbar",
          "key": "toolbar",
          "when": {
            "any": [
              "hasFilters",
              "hasSort"
            ]
          }
        },
        {
          "block": "Grid",
          "key": "grid",
          "when": "hasResults"
        },
        {
          "block": "EmptyState",
          "key": "empty",
          "when": {
            "not": "hasResults"
          }
        },
        {
          "block": "Pagination",
          "key": "pagination",
          "when": "hasMoreResults"
        }
      ],
      "card": [
        {
          "block": "Media",
          "key": "media"
        },
        {
          "block": "Title",
          "key": "title"
        },
        {
          "block": "Price",
          "key": "price"
        },
        {
          "block": "Highlights",
          "key": "highlights",
          "when": "isInCart"
        },
        {
          "block": "CartActions",
          "key": "cart-actions"
        }
      ]
    }
  },
  "clean": {
    "id": "clean",
    "version": "1.0.0",
    "meta": {
      "label": "Clean",
      "description": "Diseño ultra-limpio con header neutral, bordes sutiles y botones outlined.",
      "accentColor": "--web-color-3",
      "surfaceColor": "--web-color-1"
    },
    "regions": [
      "hero",
      "header",
      "panel",
      "card",
      "media",
      "content",
      "footer"
    ],
    "layout": {
      "hero": {
        "style": {},
        "tokens": {
          "--catalogue-hero-region-content-width": "min(1400px, 96vw)",
          "--catalogue-hero-region-padding-inline": "clamp(16px, 4vw, 48px)",
          "--catalogue-hero-region-padding-inline-mobile": "var(--catalogue-space-3)",
          "--catalogue-hero-region-gap-block": "var(--catalogue-space-4)",
          "--catalogue-hero-region-gap-block-mobile": "var(--catalogue-space-3)",
          "--catalogue-hero-padding-inline": "clamp(16px, 4vw, 48px)",
          "--catalogue-hero-padding-block": "0",
          "--catalogue-hero-shadow": "none",
          "--catalogue-hero-overlay": "none",
          "--catalogue-hero-radius": "0.5rem"
        },
        "grid": {}
      },
      "panel": {
        "style": {},
        "tokens": {
          "--catalogue-panel-shadow": "none",
          "--catalogue-panel-border": "transparent",
          "--catalogue-panel-padding-inline": "clamp(16px, 4vw, 48px)",
          "--catalogue-panel-padding-block": "clamp(16px, 4vw, 32px)",
          "--catalogue-grid-gap-x": "1.25rem",
          "--catalogue-grid-gap-y": "1.5rem"
        },
        "grid": {}
      },
      "card": {
        "style": {},
        "tokens": {
          "--catalogue-card-shadow": "none",
          "--catalogue-card-hover-shadow": "0 2px 8px rgba(0, 0, 0, 0.08)",
          "--catalogue-card-border": "rgba(0, 0, 0, 0.08)",
          "--catalogue-card-radius": "0.5rem",
          "--catalogue-card-image-radius": "0.375rem"
        },
        "grid": {}
      },
      "media": {
        "style": {},
        "tokens": {
          "--catalogue-card-image-radius": "0.375rem"
        },
        "grid": {}
      },
      "content": {
        "style": {},
        "tokens": {
          "--catalogue-space-2": "0.75rem",
          "--catalogue-text-muted": "rgba(0, 0, 0, 0.55)"
        },
        "grid": {}
      },
      "footer": {
        "style": {},
        "tokens": {
          "--catalogue-space-3": "1.25rem"
        },
        "grid": {}
      }
    },
    "slots": {
      "hero": [
        {
          "block": "Hero",
          "key": "hero",
          "when": {
            "any": [
              "hasResults",
              "hasFilters",
              "hasBanners"
            ]
          },
          "props": {
            "ratio": {
              "desktop": "3:1",
              "mobile": "2:1"
            },
            "showTitle": true
          }
        }
      ],
      "header": [
        {
          "block": "Brand",
          "key": "brand"
        },
        {
          "block": "Navigation",
          "key": "navigation",
          "when": "hasNavigation"
        },
        {
          "block": "Actions",
          "key": "actions",
          "when": "hasActions"
        },
        {
          "block": "Configurator",
          "key": "configurator",
          "when": "hasConfigurator"
        }
      ],
      "panel": [
        {
          "block": "Toolbar",
          "key": "toolbar",
          "when": {
            "any": [
              "hasFilters",
              "hasSort"
            ]
          }
        },
        {
          "block": "Grid",
          "key": "grid",
          "when": "hasResults"
        },
        {
          "block": "EmptyState",
          "key": "empty",
          "when": {
            "not": "hasResults"
          }
        },
        {
          "block": "Pagination",
          "key": "pagination",
          "when": "hasMoreResults"
        }
      ],
      "card": [],
      "media": [
        {
          "block": "Media",
          "key": "media"
        }
      ],
      "content": [
        {
          "block": "Title",
          "key": "title",
          "props": {
            "maxLines": 2
          }
        },
        {
          "block": "Price",
          "key": "price",
          "when": "hasPrice"
        },
        {
          "block": "Highlights",
          "key": "highlights",
          "when": "isInCart"
        }
      ],
      "footer": [
        {
          "block": "CartActions",
          "key": "cart-actions"
        }
      ]
    }
  },
  "minimalista": {
    "id": "minimalista",
    "version": "1.1.0",
    "meta": {
      "label": "Minimalista",
      "description": "Diseño estructural sin bordes, con hero completo y espaciado aireado.",
      "accentColor": "--web-color-3",
      "surfaceColor": "--web-color-1"
    },
    "regions": [
      "hero",
      "header",
      "panel",
      "card",
      "media",
      "content",
      "footer"
    ],
    "layout": {
      "hero": {
        "style": {},
        "tokens": {
          "--catalogue-hero-region-content-width": "min(1264px, 94vw)",
          "--catalogue-hero-region-padding-inline": "clamp(24px, 6vw, 72px)",
          "--catalogue-hero-region-padding-inline-mobile": "var(--catalogue-space-3)",
          "--catalogue-hero-region-gap-block": "var(--catalogue-space-4)",
          "--catalogue-hero-region-gap-block-mobile": "0",
          "--catalogue-hero-padding-inline": "clamp(24px, 6vw, 72px)",
          "--catalogue-hero-padding-block": "1rem",
          "--catalogue-hero-shadow": "none",
          "--catalogue-hero-overlay": "none"
        },
        "grid": {}
      },
      "panel": {
        "style": {},
        "tokens": {
          "--catalogue-panel-shadow": "none",
          "--catalogue-panel-border": "transparent",
          "--catalogue-panel-padding-inline": "clamp(16px, 5vw, 64px)",
          "--catalogue-panel-padding-block": "clamp(24px, 8vw, 88px)",
          "--catalogue-grid-gap-x": "1.75rem",
          "--catalogue-grid-gap-y": "2.5rem"
        },
        "grid": {}
      },
      "card": {
        "style": {},
        "tokens": {
          "--catalogue-card-shadow": "none",
          "--catalogue-card-hover-shadow": "0 4px 16px rgba(0, 0, 0, 0.08)",
          "--catalogue-card-border": "rgba(0, 0, 0, 0.04)",
          "--catalogue-card-radius": "0.75rem",
          "--catalogue-card-image-radius": "0.75rem",
          "--catalogue-accent": "var(--web-color-3-o1, #1677ff)"
        },
        "grid": {}
      },
      "media": {
        "style": {},
        "tokens": {
          "--catalogue-card-image-radius": "0.75rem"
        },
        "grid": {}
      },
      "content": {
        "style": {},
        "tokens": {
          "--catalogue-space-2": "0.75rem",
          "--catalogue-text-muted": "rgba(0, 0, 0, 0.55)"
        },
        "grid": {}
      },
      "footer": {
        "style": {},
        "tokens": {
          "--catalogue-space-3": "1.5rem"
        },
        "grid": {}
      }
    },
    "slots": {
      "hero": [
        {
          "block": "Hero",
          "key": "hero",
          "when": {
            "any": [
              "hasResults",
              "hasFilters",
              "hasBanners"
            ]
          },
          "props": {
            "ratio": {
              "desktop": "5:1",
              "mobile": "5:2"
            },
            "showTitle": true
          }
        }
      ],
      "header": [
        {
          "block": "Brand",
          "key": "brand"
        },
        {
          "block": "Navigation",
          "key": "navigation",
          "when": "hasNavigation"
        },
        {
          "block": "Actions",
          "key": "actions",
          "when": "hasActions"
        },
        {
          "block": "Configurator",
          "key": "configurator",
          "when": "hasConfigurator"
        }
      ],
      "panel": [
        {
          "block": "Toolbar",
          "key": "toolbar",
          "when": {
            "any": [
              "hasFilters",
              "hasSort"
            ]
          }
        },
        {
          "block": "Grid",
          "key": "grid",
          "when": "hasResults"
        },
        {
          "block": "EmptyState",
          "key": "empty",
          "when": {
            "not": "hasResults"
          }
        },
        {
          "block": "Pagination",
          "key": "pagination",
          "when": "hasMoreResults"
        }
      ],
      "card": [],
      "media": [
        {
          "block": "Media",
          "key": "media"
        }
      ],
      "content": [
        {
          "block": "Title",
          "key": "title",
          "props": {
            "maxLines": 2
          }
        },
        {
          "block": "Price",
          "key": "price",
          "when": "hasPrice"
        },
        {
          "block": "Highlights",
          "key": "highlights",
          "when": "isInCart"
        }
      ],
      "footer": [
        {
          "block": "CartActions",
          "key": "cart-actions"
        }
      ]
    },
    "catalogueLinkStyle": "text"
  },
  "moderno": {
    "id": "moderno",
    "version": "1.1.0",
    "meta": {
      "label": "Moderno",
      "description": "Diseño estructural sin bordes, con hero completo y espaciado aireado.",
      "accentColor": "--web-color-3",
      "surfaceColor": "--web-color-1"
    },
    "regions": [
      "hero",
      "header",
      "panel",
      "card",
      "media",
      "content",
      "footer"
    ],
    "layout": {
      "hero": {
        "style": {},
        "tokens": {
          "--catalogue-hero-region-content-width": "min(1264px, 94vw)",
          "--catalogue-hero-region-padding-inline": "clamp(24px, 6vw, 72px)",
          "--catalogue-hero-region-padding-inline-mobile": "var(--catalogue-space-3)",
          "--catalogue-hero-region-gap-block": "var(--catalogue-space-4)",
          "--catalogue-hero-region-gap-block-mobile": "0",
          "--catalogue-hero-padding-inline": "clamp(24px, 6vw, 72px)",
          "--catalogue-hero-padding-block": "clamp(32px, 9vw, 50px)",
          "--catalogue-hero-shadow": "none",
          "--catalogue-hero-overlay": "none"
        },
        "grid": {}
      },
      "panel": {
        "style": {},
        "tokens": {
          "--catalogue-panel-shadow": "none",
          "--catalogue-panel-border": "transparent",
          "--catalogue-panel-padding-inline": "clamp(16px, 5vw, 64px)",
          "--catalogue-panel-padding-block": "clamp(24px, 8vw, 88px)",
          "--catalogue-grid-gap-x": "1.75rem",
          "--catalogue-grid-gap-y": "2.5rem"
        },
        "grid": {}
      },
      "card": {
        "style": {},
        "tokens": {
          "--catalogue-card-shadow": "none",
          "--catalogue-card-hover-shadow": "0 4px 16px rgba(0, 0, 0, 0.08)",
          "--catalogue-card-border": "rgba(0, 0, 0, 0.04)",
          "--catalogue-card-radius": "0.75rem",
          "--catalogue-card-image-radius": "0.75rem",
          "--catalogue-accent": "var(--web-color-3-o1, #1677ff)"
        },
        "grid": {}
      },
      "media": {
        "style": {},
        "tokens": {
          "--catalogue-card-image-radius": "0.75rem"
        },
        "grid": {}
      },
      "content": {
        "style": {},
        "tokens": {
          "--catalogue-space-2": "0.75rem",
          "--catalogue-text-muted": "rgba(0, 0, 0, 0.55)"
        },
        "grid": {}
      },
      "footer": {
        "style": {},
        "tokens": {
          "--catalogue-space-3": "1.5rem"
        },
        "grid": {}
      }
    },
    "slots": {
      "hero": [
        {
          "block": "Hero",
          "key": "hero",
          "when": {
            "any": [
              "hasResults",
              "hasFilters",
              "hasBanners"
            ]
          },
          "props": {
            "ratio": {
              "desktop": "5:1",
              "mobile": "5:2"
            },
            "showTitle": true
          }
        }
      ],
      "header": [
        {
          "block": "Brand",
          "key": "brand"
        },
        {
          "block": "Navigation",
          "key": "navigation",
          "when": "hasNavigation"
        },
        {
          "block": "Actions",
          "key": "actions",
          "when": "hasActions"
        },
        {
          "block": "Configurator",
          "key": "configurator",
          "when": "hasConfigurator"
        }
      ],
      "panel": [
        {
          "block": "Toolbar",
          "key": "toolbar",
          "when": {
            "any": [
              "hasFilters",
              "hasSort"
            ]
          }
        },
        {
          "block": "Grid",
          "key": "grid",
          "when": "hasResults"
        },
        {
          "block": "EmptyState",
          "key": "empty",
          "when": {
            "not": "hasResults"
          }
        },
        {
          "block": "Pagination",
          "key": "pagination",
          "when": "hasMoreResults"
        }
      ],
      "card": [],
      "media": [
        {
          "block": "Media",
          "key": "media"
        }
      ],
      "content": [
        {
          "block": "Title",
          "key": "title",
          "props": {
            "maxLines": 2
          }
        },
        {
          "block": "Price",
          "key": "price",
          "when": "hasPrice"
        },
        {
          "block": "Highlights",
          "key": "highlights",
          "when": "isInCart"
        }
      ],
      "footer": [
        {
          "block": "CartActions",
          "key": "cart-actions"
        }
      ]
    },
    "catalogueLinkStyle": "icon"
  },
  "soft-commerce": {
    "id": "soft-commerce",
    "version": "1.0.0",
    "meta": {
      "label": "Soft Commerce",
      "description": "Diseño claro y elevado para catálogos con foco en producto.",
      "accentColor": "--web-color-3",
      "surfaceColor": "--web-color-1"
    },
    "regions": [
      "hero",
      "header",
      "panel",
      "toolbar",
      "aside",
      "card",
      "media",
      "content",
      "footer"
    ],
    "layout": {
      "hero": {
        "style": {},
        "tokens": {
          "--catalogue-hero-region-content-width": "min(1500px, 94vw)",
          "--catalogue-hero-region-padding-inline": "var(--catalogue-panel-padding-inline)",
          "--catalogue-hero-region-padding-inline-mobile": "var(--catalogue-space-3)",
          "--catalogue-hero-region-gap-block": "16px",
          "--catalogue-hero-region-gap-block-mobile": "18px",
          "--catalogue-hero-padding-inline": "clamp(24px, 6vw, 72px)",
          "--catalogue-hero-padding-block": "clamp(28px, 5vw, 52px)",
          "--catalogue-hero-shadow": "0 10px 30px rgba(15, 42, 80, 0.08)",
          "--catalogue-hero-overlay": "none"
        },
        "grid": {}
      },
      "panel": {
        "style": {},
        "tokens": {
          "--catalogue-panel-shadow": "none",
          "--catalogue-panel-border": "transparent",
          "--catalogue-panel-padding-inline": "clamp(18px, 4vw, 54px)",
          "--catalogue-panel-padding-block": "clamp(18px, 4vw, 32px)",
          "--catalogue-grid-gap-x": "1.5rem",
          "--catalogue-grid-gap-y": "1.5rem"
        },
        "grid": {
          "xs": 12,
          "sm": 12,
          "md": 8,
          "lg": 6,
          "xl": 6,
          "xxl": 6,
          "gutter": [
            24,
            24
          ]
        }
      },
      "card": {
        "style": {},
        "tokens": {
          "--catalogue-card-shadow": "0 8px 22px rgba(15, 42, 80, 0.06)",
          "--catalogue-card-hover-shadow": "0 10px 28px rgba(15, 42, 80, 0.1)",
          "--catalogue-card-border": "#e6edf5",
          "--catalogue-card-radius": "1rem",
          "--catalogue-card-image-radius": "0.75rem",
          "--catalogue-accent": "#0b78ff"
        },
        "grid": {}
      },
      "media": {
        "style": {},
        "tokens": {
          "--catalogue-card-image-radius": "0.75rem"
        },
        "grid": {}
      },
      "content": {
        "style": {},
        "tokens": {
          "--catalogue-space-2": "0.75rem",
          "--catalogue-text-muted": "#667085"
        },
        "grid": {}
      },
      "footer": {
        "style": {},
        "tokens": {
          "--catalogue-space-3": "1rem"
        },
        "grid": {}
      }
    },
    "slots": {
      "hero": [
        {
          "block": "Hero",
          "key": "hero",
          "when": {
            "any": [
              "hasResults",
              "hasFilters",
              "hasBanners"
            ]
          },
          "props": {
            "ratio": {
              "desktop": "19:3",
              "mobile": "2:1"
            },
            "showTitle": true
          }
        }
      ],
      "header": [
        {
          "block": "Brand",
          "key": "brand"
        },
        {
          "block": "HeaderSearch",
          "key": "search",
          "area": "navigation"
        },
        {
          "block": "Navigation",
          "key": "navigation",
          "area": "navigation",
          "when": "hasNavigation"
        },
        {
          "block": "Actions",
          "key": "actions",
          "area": "trailing",
          "when": "hasActions"
        },
        {
          "block": "Configurator",
          "key": "configurator",
          "area": "trailing",
          "when": "hasConfigurator"
        }
      ],
      "panel": [
        {
          "block": "SoftCommercePanelLayout",
          "key": "layout",
          "slots": {
            "heading": [
              {
                "block": "PanelHeading",
                "key": "heading"
              }
            ],
            "topFilters": [
              {
                "block": "Toolbar",
                "key": "toolbar",
                "when": {
                  "any": [
                    "hasFilters",
                    "hasSort"
                  ]
                }
              }
            ],
            "grid": [
              {
                "block": "Grid",
                "key": "grid",
                "when": "hasResults"
              }
            ],
            "empty": [
              {
                "block": "EmptyState",
                "key": "empty",
                "when": {
                  "not": "hasResults"
                }
              }
            ],
            "pagination": [
              {
                "block": "Pagination",
                "key": "pagination",
                "when": "hasMoreResults"
              }
            ]
          }
        }
      ],
      "card": [],
      "media": [
        {
          "block": "Media",
          "key": "media"
        }
      ],
      "content": [
        {
          "block": "StockBadge",
          "key": "stock"
        },
        {
          "block": "Title",
          "key": "title",
          "props": {
            "maxLines": 2
          }
        },
        {
          "block": "Highlights",
          "key": "highlights",
          "when": "isInCart"
        }
      ],
      "footer": [
        {
          "block": "Price",
          "key": "price",
          "when": "hasPrice"
        },
        {
          "block": "CartActions",
          "key": "cart-actions"
        }
      ]
    },
    "catalogueLinkStyle": "both",
    "catalogueLinkText": "Inicio"
  },
  "performance-test": {
    "id": "performance-test",
    "version": "1.0.0",
    "meta": {
      "label": "Performance Test",
      "description": "Diseño para benchmark de resolución dinámica.",
      "accentColor": "--web-color-3",
      "surfaceColor": "--web-color-1"
    },
    "regions": [
      "hero",
      "header",
      "panel",
      "toolbar",
      "aside",
      "card",
      "media",
      "content",
      "footer"
    ],
    "layout": {
      "hero": {
        "style": {},
        "tokens": {
          "--catalogue-hero-region-content-width": "min(1500px, 94vw)",
          "--catalogue-hero-region-padding-inline": "var(--catalogue-panel-padding-inline)",
          "--catalogue-hero-region-padding-inline-mobile": "var(--catalogue-space-3)",
          "--catalogue-hero-region-gap-block": "16px",
          "--catalogue-hero-region-gap-block-mobile": "18px",
          "--catalogue-hero-padding-inline": "clamp(24px, 6vw, 72px)",
          "--catalogue-hero-padding-block": "clamp(28px, 5vw, 52px)",
          "--catalogue-hero-shadow": "0 10px 30px rgba(15, 42, 80, 0.08)",
          "--catalogue-hero-overlay": "none"
        },
        "grid": {}
      },
      "panel": {
        "style": {},
        "tokens": {
          "--catalogue-panel-shadow": "none",
          "--catalogue-panel-border": "transparent",
          "--catalogue-panel-padding-inline": "clamp(18px, 4vw, 54px)",
          "--catalogue-panel-padding-block": "clamp(18px, 4vw, 32px)",
          "--catalogue-grid-gap-x": "1.5rem",
          "--catalogue-grid-gap-y": "1.5rem"
        },
        "grid": {
          "xs": 12,
          "sm": 12,
          "md": 8,
          "lg": 6,
          "xl": 6,
          "xxl": 6,
          "gutter": [
            24,
            24
          ]
        }
      },
      "card": {
        "style": {},
        "tokens": {
          "--catalogue-card-shadow": "0 8px 22px rgba(15, 42, 80, 0.06)",
          "--catalogue-card-hover-shadow": "0 10px 28px rgba(15, 42, 80, 0.1)",
          "--catalogue-card-border": "#e6edf5",
          "--catalogue-card-radius": "1rem",
          "--catalogue-card-image-radius": "0.75rem",
          "--catalogue-accent": "#0b78ff"
        },
        "grid": {}
      },
      "media": {
        "style": {},
        "tokens": {
          "--catalogue-card-image-radius": "0.75rem"
        },
        "grid": {}
      },
      "content": {
        "style": {},
        "tokens": {
          "--catalogue-space-2": "0.75rem",
          "--catalogue-text-muted": "#667085"
        },
        "grid": {}
      },
      "footer": {
        "style": {},
        "tokens": {
          "--catalogue-space-3": "1rem"
        },
        "grid": {}
      }
    },
    "slots": {
      "hero": [
        {
          "block": "Hero",
          "key": "hero",
          "when": {
            "any": [
              "hasResults",
              "hasFilters",
              "hasBanners"
            ]
          },
          "props": {
            "ratio": {
              "desktop": "19:3",
              "mobile": "2:1"
            },
            "showTitle": true
          }
        }
      ],
      "header": [
        {
          "block": "Brand",
          "key": "brand"
        },
        {
          "block": "HeaderSearch",
          "key": "search",
          "area": "navigation"
        },
        {
          "block": "Navigation",
          "key": "navigation",
          "area": "navigation",
          "when": "hasNavigation"
        },
        {
          "block": "Actions",
          "key": "actions",
          "area": "trailing",
          "when": "hasActions"
        },
        {
          "block": "Configurator",
          "key": "configurator",
          "area": "trailing",
          "when": "hasConfigurator"
        }
      ],
      "panel": [
        {
          "block": "SoftCommercePanelLayout",
          "key": "layout",
          "slots": {
            "heading": [
              {
                "block": "PanelHeading",
                "key": "heading"
              }
            ],
            "topFilters": [
              {
                "block": "Toolbar",
                "key": "toolbar",
                "when": {
                  "any": [
                    "hasFilters",
                    "hasSort"
                  ]
                }
              }
            ],
            "grid": [
              {
                "block": "Grid",
                "key": "grid",
                "when": "hasResults"
              }
            ],
            "empty": [
              {
                "block": "EmptyState",
                "key": "empty",
                "when": {
                  "not": "hasResults"
                }
              }
            ],
            "pagination": [
              {
                "block": "Pagination",
                "key": "pagination",
                "when": "hasMoreResults"
              }
            ]
          }
        }
      ],
      "card": [],
      "media": [
        {
          "block": "Media",
          "key": "media"
        }
      ],
      "content": [
        {
          "block": "StockBadge",
          "key": "stock"
        },
        {
          "block": "Title",
          "key": "title",
          "props": {
            "maxLines": 2
          }
        },
        {
          "block": "Highlights",
          "key": "highlights",
          "when": "isInCart"
        }
      ],
      "footer": [
        {
          "block": "Price",
          "key": "price",
          "when": "hasPrice"
        },
        {
          "block": "CartActions",
          "key": "cart-actions"
        }
      ]
    },
    "catalogueLinkStyle": "both",
    "catalogueLinkText": "Inicio"
  }
};

export type PrecompiledDesignKey = keyof typeof PRECOMPILED_DEFINITIONS;
